// extracted by mini-css-extract-plugin
export default {"wrapper":"ED-z","viewport":"FD-z","container":"GD-z","slide":"HD-z"};